/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import type { UINotification } from '@poweralpha/common';
import { useEffect, useMemo, useRef } from 'react';
import { toast } from 'react-toastify';
import { notificationContainerId, showNotificationToast } from './showNotificationToast';

function useNotificationToasts(
  notifications: Array<UINotification> | undefined,
  handleClick: (notif: UINotification, redirect?: boolean) => void,
) {
  const unread = useMemo(() => notifications?.filter((notif) => !notif.viewed_at), [notifications]);
  const seenIdsRef = useRef<Set<string> | null>(null);

  useEffect(() => {
    if (!unread) return;

    const unreadIds = new Set(unread.map(({ id }) => id));
    const previousUnreadIds = seenIdsRef.current ?? new Set<string>();

    if (unread.length === 0) {
      if (previousUnreadIds.size > 0) {
        toast.dismiss({ containerId: notificationContainerId });
        toast.clearWaitingQueue({ containerId: notificationContainerId });
      }
      seenIdsRef.current = unreadIds;
      return;
    }

    const nextNotifs = unread.filter(({ id }) => !previousUnreadIds.has(id));
    nextNotifs.forEach((notif) => {
      showNotificationToast(notif, handleClick);
    });
    seenIdsRef.current = unreadIds;
  }, [handleClick, unread]);
}

export default useNotificationToasts;
